import React from 'react'
import PropTypes from 'prop-types'
import { Lock as LockIcon } from '@mui/icons-material_modern'
import { IconButton, Tooltip } from '@mui/material_modern'
import { getPaymentHoldText, paymentHoldInEffect } from 'components/containers/inbound-tickets/helpers/grid-validations'

const PaymentHoldTooltip = ({ rulesArray, effectiveDateValue, listView }) =>
  rulesArray?.length > 0 && paymentHoldInEffect(rulesArray, effectiveDateValue) ? (
    <Tooltip title={getPaymentHoldText(rulesArray, effectiveDateValue)}>
      <IconButton size="small" sx={{ ...(listView && { width: '20px', height: '20px' }) }}>
        <LockIcon />
      </IconButton>
    </Tooltip>
  ) : null

PaymentHoldTooltip.propTypes = {
  rulesArray: PropTypes.array,
  effectiveDateValue: PropTypes.string,
  listView: PropTypes.bool,
}

PaymentHoldTooltip.defaultProps = {
  rulesArray: [],
  effectiveDateValue: '',
  listView: false,
}

export default PaymentHoldTooltip
